import { Card, Col, Menu, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { HELP_TOPICS } from '../help/topics';

export function HelpPage() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get('topic') ?? HELP_TOPICS[0]!.id;
  const active =
    HELP_TOPICS.find((topic) => topic.id === requested) ?? HELP_TOPICS[0]!;

  return (
    <Card title={t('nav.help')}>
      <Row gutter={16}>
        <Col xs={24} md={5}>
          <Menu
            mode="inline"
            selectedKeys={[active.id]}
            items={HELP_TOPICS.map((topic) => ({
              key: topic.id,
              label: t(topic.titleKey),
            }))}
            onClick={({ key }) => setSearchParams({ topic: key })}
          />
        </Col>
        <Col xs={24} md={19}>
          <Typography.Title level={4} style={{ marginTop: 0 }}>
            {t(active.titleKey)}
          </Typography.Title>
          <div className="help-topic-content">{active.content}</div>
        </Col>
      </Row>
    </Card>
  );
}
